<template>
  <vs-popup :active.sync="open"
            :buttons-hidden="true"
            @close="open = false"
            class="assign-formulation-stock-inventory-pop-up"
            title="CREATE RM STOCK INVENTORY">
    <vx-card no-shadow >
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-rm-stock-inventory" @submit.prevent="handleSubmit(onClickAssign)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="company_product_code" name="company_product_code" rules="required" v-slot="{ errors }">
                <small class="label">ITS Product Code</small>
                <vs-input disabled :value="rm_item.category.prefix + '-' + rm_item.company_product_code"   name="company_product_code" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="supplier_batch_no" name="supplier_batch_no" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Batch Number</small>
                <vs-input v-model="form.supplier_batch_no"   name="supplier_batch_no" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="manufacture_date" name="manufacture_date" rules="required" v-slot="{ errors }">
                <small class="label">Manufacturing Date</small>
                <flat-pickr
                  :config="{dateFormat: 'd/m/Y', maxDate: 'today'}"
                  class="hidden"
                  v-model="form.manufacture_date"
                  placeholder="Choose Manufacture Date"/>

                <flat-pickr :config="{dateFormat: 'd/m/Y', maxDate: 'today'}" class="w-full" v-model="form.manufacture_date"
                            placeholder="Choose Manufacture Date"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="expiration_date" name="expiration_date" rules="required" v-slot="{ errors }">
                <small class="label">ITS Expiry Date</small>
                <flat-pickr
                  :config="{dateFormat: 'd/m/Y'}"
                  class="hidden"
                  v-model="form.expiration_date"
                  placeholder="Choose Expiration Date"/>

                <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" v-model="form.expiration_date"
                            placeholder="Choose Expiration Date"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="quantity" name="quantity" :rules="`required|number|min_qty:${rm_item.quantity_pending_to_receive}`" v-slot="{ errors }">
                <small class="label">Quantity (Kg)</small>
                <vs-input v-model="form.quantity"   name="quantity" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <h6 class="mb-2 mt-4">Shelf Location</h6>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="shelf_location_r" name="shelf_location_r" rules="required" v-slot="{ errors }">
                <vx-input-group>
                  <template slot="prepend">
                    <div class="prepend-text bg-primary">
                      <span>R</span>
                    </div>
                  </template>
                  <v-select v-model="form.shelf_location_r" style="border-radius: 0; z-index: 9" :options="shelf_location_r_options" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                </vx-input-group>
                <small class="text-danger">{{errors[0]}}</small>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="shelf_location_s" name="shelf_location_s" rules="required" v-slot="{ errors }">
                <vx-input-group>
                  <template slot="prepend">
                    <div class="prepend-text bg-primary">
                      <span>S</span>
                    </div>
                  </template>
                  <v-select v-model="form.shelf_location_s" style="border-radius: 0; z-index: 9" :options="shelf_location_s_options" :dir="$vs.rtl ? 'rtl' : 'ltr'" />

                </vx-input-group>
                <small class="text-danger">{{errors[0]}}</small>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="shelf_location_l" name="shelf_location_l" rules="required" v-slot="{ errors }">
                <vx-input-group>
                  <template slot="prepend">
                    <div class="prepend-text bg-primary">
                      <span>L</span>
                    </div>
                  </template>
                  <v-select v-model="form.shelf_location_l" style="border-radius: 0; z-index: 9" :options="shelf_location_l_options" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                </vx-input-group>
                <small class="text-danger">{{errors[0]}}</small>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="form = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>

        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const ManufacturingRepository = RepositoryFactory.get('manufacturing');
  const SettingsRepository = RepositoryFactory.get('settings');
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'

  import {
    mapActions, mapGetters
  } from 'vuex'

  function initialState() {
    return {
      open: false,
      id: '',
      shelf_location_r_options: [],
      shelf_location_s_options: [],
      shelf_location_l_options: [],
      form: {
        manufacture_date: '',
        expiration_date: '',
        supplier_batch_no: '',
        batch_no: '',
        company_product_code: '',
        category: '',
        quantity: ''
      },
      rm_item: { prefix: '' },
      qc_id: '',
    }
  }

  export default {
    name: 'CreateRmStockPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(rm_item, qc_id) {
        try {
          await Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.rm_item = rm_item;
          this.qc_id = qc_id;
          this.form.quantity = rm_item.quantity_pending_to_receive
          await this.generateShelfLocationOptions()
          this.open = true;
        } catch (error) {

        }
      },
      async closePopup() {
        this.open = false;
      },
      async onClickAssign() {
        const vue = this
        await this.$vs.loading({
          container: '#create-rm-stock-inventory',
          scale: 0.45
        })
        try {
          const payload = {
            staff_raw_material_order_item_id: this.rm_item.id,
            supplier_raw_material_id: this.rm_item.raw_material_id,
            quantity: this.form.quantity,
            supplier_batch_no: this.form.supplier_batch_no,
            shelf_location_r: this.form.shelf_location_r,
            shelf_location_s: this.form.shelf_location_s,
            shelf_location_l: this.form.shelf_location_l,
            manufacture_date: this.form.manufacture_date,
            expiration_date: this.form.expiration_date,
            staff_r_m_item_q_c_test_id: this.qc_id
          }
          await ManufacturingRepository.createRawMaterialStock(payload)
          this.showSuccessMessage('Raw Material Stock Inventory created!')
          await this.closePopup()
          await vue.$parent.refreshData()
          this.$vs.loading.close('#create-rm-stock-inventory > .con-vs-loading')
        } catch (e) {
          this.showErrorMessage(e)
          this.$vs.loading.close('#create-rm-stock-inventory > .con-vs-loading')
        }

      },
      async generateShelfLocationOptions() {

        const settings = (await SettingsRepository.getTheItem('shelf_location_r_from,shelf_location_r_to,shelf_location_s_from,shelf_location_s_to,shelf_location_l_from,shelf_location_l_to')).data.data

        let r_from = settings.shelf_location_r_from
        let r_to = settings.shelf_location_r_to

        let s_from = settings.shelf_location_s_from
        let s_to = settings.shelf_location_s_to

        let l_from = settings.shelf_location_l_from
        let l_to = settings.shelf_location_l_to

        let start_r = Number(r_from)
        const end_r = Number(r_to)

        let start_s = Number(s_from)
        const end_s = Number(s_to)

        let start_l = Number(l_from)
        const end_l = Number(l_to)

        while (start_r <= end_r) {
          this.shelf_location_r_options.push(start_r.toString());
          start_r++;
        }

        while (start_s <= end_s) {
          this.shelf_location_s_options.push(start_s.toString());
          start_s++;
        }

        while (start_l <= end_l) {
          this.shelf_location_l_options.push(start_l.toString());
          start_l++;
        }

      }
    },
    components: {
      flatPickr,
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .assign-formulation-stock-inventory-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }

</style>
